<template>
    <v-card>
        <v-card-title>
        <span class="headline">Cargo Commodity Detail</span>
      </v-card-title>
      <v-card-text>
        <message :messages="messages"></message>
        <form>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs6 v-if="newComdty">
                <v-text-field :label="labels.comdty" v-model="comdtyForm.comdty" :error-messages="errors.collect('comdty')" data-vv-name="comdty" :data-vv-as="labels.comdty" v-validate="'required|param|max:8'"></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{labels.comdty}}</v-subheader>
                <div class="title">{{comdtyForm.comdty}}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="comdtyForm.comdtyDesc" :label="labels.comdtyDesc" :error-messages="errors.collect('comdtyDesc')" v-validate="'required|entry|max:100'" data-vv-name="comdtyDesc" :data-vv-as="labels.comdtyDesc"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat @click.native="doCancel">Cancel</v-btn>
        <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'

export default {
  props: {
    'comdtyForm': Object,
    'newComdty': Boolean
  },
  data() {
    return {
      labels: {
        comdty: 'Commodity Code*',
        comdtyDesc: 'Commodity Description*'
      },
      submitting: undefined
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
      this.comdtyForm.comdty = undefined
      this.comdtyForm.comdtyDesc = undefined
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newComdty) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.cargo.menu.createComdty
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.comdtyForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doUpdate() {
      const apiURI = this.$store.state.cargo.menu.updateComdty
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.comdtyForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doCancel() {
      this.doInit()
      this.$emit('close')
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
